import { Component, inject, Input, ChangeDetectionStrategy } from '@angular/core';
import { IonButton, IonIcon, ModalController } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { ConnectivityService } from '@okcargo-apps/shared-infrastructure';
import { HelpTrafficModalComponent } from '../help-traffic-modal/help-traffic-modal.component';

@Component({
  selector: 'lib-incidence-button',
  templateUrl: './incidence-button.component.html',
  styleUrls: ['./incidence-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IonIcon, IonButton, TranslateModule],
})
export class IncidenceButtonComponent {
  private readonly modalCtrl = inject(ModalController);
  private readonly connectivity = inject(ConnectivityService);

  /** The incidence modal queries traffic information: it needs connection. */
  protected readonly isOffline = this.connectivity.isOffline;

  @Input()
  reference = '';

  async showIncidenceModal(): Promise<void> {
    if (this.isOffline()) return;

    const modal = await this.modalCtrl.create({
      // TODO change when new model of incidents and message was implemented
      // component: IncidenceModalComponent,
      component: HelpTrafficModalComponent,
      componentProps: {
        // stop: this.freight.stops.find(
        //   (stop) => stop.id === this.freight.nextStopId
        // ),
        // freightId: this.freight.id,
        reference: this.reference,
      },
      backdropDismiss: false,
    });
    modal.present();
  }
}
